function downloadImage(imageId, blobData, type = 'image/png') {
  const blob = new Blob([blobData], { type });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = `${imageId}.png`;
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);
}

export default downloadImage;
